import React from 'react'
import { useDisplayTheme } from 'hooks/useUiState'
import { Theme } from 'features/ui/types'
import { MessageConst } from 'enums'
import styled from 'styled-components'
// @ts-ignore
import { sys } from '@netbasequid/theme'

const StyledEmDash = styled.span`
  color: ${({ mode }: { mode: Theme }) => sys[mode].text.placeholder};
`

const DashSymbol = () => {
  const theme = useDisplayTheme() as Theme

  return <StyledEmDash mode={theme}>{MessageConst.EM_DASH}</StyledEmDash>
}

export default DashSymbol
